import PropTypes from 'prop-types';
import styles from './GlossaryPagination.module.scss';

export const GlossaryPagination = ({ anchors }) => (
	<div className={styles.container}>
		{anchors?.map((elem, key) =>
			elem.id ? (
				<a key={key} className={styles.element} href={`#${elem.id}`}>
					{elem.name}
				</a>
			) : (
				<span key={key} className={styles.element} data-test-id="glossary-pagination-span">
					{elem.name}
				</span>
			),
		)}
	</div>
);

GlossaryPagination.propTypes = {
	anchors: PropTypes.array.isRequired,
};

export default GlossaryPagination;
